import actionTypes from '../constants/action-types';

const setGlobalHTML = (globalId, html) => ({
  type: actionTypes.SET_GLOBAL_HTML,
  payload: {
    globalId,
    html,
  },
});

export default setGlobalHTML;
